<template>
    <div class="personal-account-page">
        <div class="page-title">
            <h4 v-if='this.user'> {{$t('txt.contulMeu')}}</h4>
        </div>
        <div class="points-status-wrapper">
            <h4> {{$t('placeholder.statusPuncteRecompensa')}} </h4>
            <div class="points-status-inner">
                <div class="points-status-counter" id="points-counter">
                    <i class="far fa-star"></i>
                    <span> {{user.points}} </span>
                </div>
                <div class="points-status">
                    <img src="../../assets/images/cowboyface.png" alt="cowboy-face">
                    <div id="smile-container">
                        <div class="smile-status"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="account-detail-box">
                    <ul class="account-detail-list">
                        <li v-for="input_field in input_fields.column_1" :key="input_field.id">
                          <div class="view-info-wrapper">
                            <div class="contact-design">
                                <i :class="input_field.icon"></i>
                                <span> {{input_field.labelName}} </span>
                            </div>
                            <p> {{input_field.inputValue}} </p>
                          </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                <form class="add-user-form" id="change-pass" method="POST">
                    <input type="hidden" name="_method" value="put" />
                    <div>
                        <div class="user-headers">
                            <h4> {{ $t('txt.modificaParola') }} </h4>
                        </div>
                        <div class="form-group"
                             v-for="input_field in input_pass_fields.column_1"
                             :key="input_field.id">
                            <input type="password" class="form-control"
                                   placeholder=""
                                   v-validate="input_field.validationRules"
                                   :data-vv-as="input_field.labelName"
                                   v-bind:name="input_field.inputName"
                                   :ref="input_field.inputName"
                                   v-bind:id="input_field.inputName">
                            <label class=""> {{input_field.labelName}} </label>
                            <span class="focus-input"></span>
                            <span class="symbol-input">
                                  <i v-bind:class="input_field.icon"></i>
                              </span>
                            <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                        </div>
                        <div class="">
                            <div class="save-contact-buttons">
                                <button @click.prevent='changePassword()' :disabled="this.$store.state.loading">
                                    <i class="fas fa-check"></i>
                                    {{$t('txt.salveazaParola')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-12 col-12" v-if="$hasRole('partner')">
                <form class="user-offer-data" id="partner-offer-data">
                    <div>
                        <div class="user-headers">
                            <h4> {{ $t('txt.modificaDateUserOferta') }} </h4>
                        </div>
                        <div class="type-user">
                            <label class="container_check">
                                <input type="radio" value="1" name="type" @click="userType(1)" v-model="user.type">
                                <span class="checkmark"></span>
                                {{$t('txt.persFizica')}}
                            </label>
                            <label class="container_check">
                                <input type="radio" value="2" name="type"  @click="userType(2)" v-model="user.type">
                                <span class="checkmark"></span>
                                {{$t('txt.persJuridica')}}
                            </label>
                        </div>
                        <div class="person_type1" v-if="this.type1">
                            <div class="form-group"
                                 v-for="input_field in input_offer_fields.column_1"
                                 :key="input_field.id">
                                <input :type="input_field.type" class="form-control"
                                       placeholder=""
                                       v-validate="input_field.validationRules"
                                       :data-vv-as="input_field.labelName"
                                       v-model="input_field.inputValue"
                                       v-bind:name="input_field.inputName"
                                       :ref="input_field.inputName"
                                       v-bind:id="input_field.inputName">
                                <label class=""> {{input_field.labelName}} </label>
                                <span class="focus-input"></span>
                                <span class="symbol-input">
                                      <i v-bind:class="input_field.icon"></i>
                                  </span>
                                <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                            </div>
                        </div>
                        <div class="person_type2" v-else>
                             <div class="form-group"
                                  v-for="input_field in input_offer_fields.column_2"
                                  :key="input_field.id">
                                 <input :type="input_field.type" class="form-control"
                                        placeholder=""
                                        v-validate="input_field.validationRules"
                                        :data-vv-as="input_field.labelName"
                                        v-model="input_field.inputValue"
                                        v-bind:name="input_field.inputName"
                                        :ref="input_field.inputName"
                                        v-bind:id="input_field.inputName">
                                 <label class=""> {{input_field.labelName}} </label>
                                 <span class="focus-input"></span>
                                 <span class="symbol-input">
                                       <i v-bind:class="input_field.icon"></i>
                                   </span>
                                 <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                             </div>
                            <div class="selections-option" @click="selected_label = 1">
                                <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.judet')}} </label>
                                <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                                    <i class="fas fa-city"></i>
                                </div>
                                <v-select v-model="select_county" :options="counties" label="name"
                                          @input="getCitiesByCounty()">
                                </v-select>
                            </div>
                            <div class="selections-option">
                                <label :class="{select_label_class:selected_label === 2}"> {{$t('placeholder.oras')}} </label>
                                <div class="symbol-input" :class="{symbol_input_class:selected_label === 2}">
                                    <i class="fas fa-city"></i>
                                </div>
                                <v-select v-model="select_city" :options="cities" label="name"></v-select>
                            </div>
                        </div>
                        <div class="save-profile-data">
                            <div class="save-contact-buttons">
                                <button  @click.prevent="saveOfferPartnerData" :disabled="this.$store.state.loading">
                                    <i class="fas fa-check"></i>
                                    {{$t('txt.salveazaDate')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                <div class="user-logo-section" v-if="$hasRole('partner')">
                    <h4> {{$t('placeholder.incarcaImagine')}} </h4>
                    <div class="user-logo-container" v-if="this.user">
                        <div class="user-logo">
                            <img :src="logo">
                        </div>
                    </div>
                    <form id="change-logo" class="add-user-form" >
                        <input type="hidden" name="_method" value="put">
                        <div class="upload-logo">
                            <b-form-file
                                    name="files[]"
                                    v-model="file"
                                    ref="file-input"
                                    :state="Boolean(file)"
                                    :placeholder="$t('placeholder.dropPhotoHere')"
                                    :drop-placeholder="$t('placeholder.dropPhotoHere')"
                            ></b-form-file>
                        </div>
                        <div class="col-12">
                            <div class="save-logo-button">
                                <button @click.prevent='changeLogo()' :disabled="this.$store.state.loading">
                                    <i class="fas fa-check"></i>
                                    {{$t('placeholder.salveazaLogo')}}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UsersService from '../../api-services/users.service.js'
import PartnersService from '../../api-services/partners.service.js'
import CountiesService from '../../api-services/counties.service.js'

export default {
  name: 'Viewuser',
  data () {
    return {
      selected_label: null,
      form_type: false,
      logo: null,
      type1: null,
      file: null,
      type: null,
      user: this.$store.getters.user,
      offerData: [],
      counties: [],
      select_county: null,
      cities_location: [],
      cities: [],
      select_city: null,
      mimes: ['image/jpeg', 'image/jpg', 'image/png']
    }
  },
  methods: {
    getCounties () {
      CountiesService.getAll({ per_page: -1 })
        .then((response) => {
          this.counties = response.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCitiesByCounty () {
      let countyId = (this.select_county) ? this.select_county.id : null
      this.cities = []
      this.select_city = null
      if (countyId && countyId > 0) {
        CountiesService.get(countyId)
          .then((response) => {
            this.cities = response.data.data.cities
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    getCitiesByCountyLocation () {
      let county = this.input_fields.location.find(county => county.inputName === 'location_county')
      let city = this.input_fields.location.find(city => city.inputName === 'location_city')
      if (county) {
        let countyId = (county.inputValue) ? county.inputValue.id : null
        this.cities_location = []
        city.inputValue = null
        if (countyId && countyId > 0) {
          CountiesService.get(countyId)
            .then((response) => {
              this.cities_location = response.data.data.cities
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    },
    getUserOfferData () {
      UsersService.getOfferData(this.user.id)
        .then((response) => {
          this.offerData = response.data.data
          this.select_city = response.data.data.city.name
          this.select_county = response.data.data.county.name
        })
        .catch((error) => {
          console.log(error)
        })
    },
    userType (value) {
      switch (value) {
        case 1: this.type1 = true
          break
        case 2: this.type1 = false
          break
      }
    },
    saveOfferPartnerData () {
      let data = new FormData(document.getElementById('partner-offer-data'))
      data.append('user_id', this.user.id)
      if (this.select_city !== null) {
        data.append('city_id', this.select_city.id)
      }
      if (this.select_county !== null) {
        data.append('county_id', this.select_county.id)
      }

      PartnersService.savePartnersOfferData(data)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.dateOfertaUser'),
              'animation-type': 'css'
            })
            // var frm = document.getElementById('test-id')
            // alert(frm.offsetTop)
            window.scrollTo(0, 0)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    checkLogo () {
      if (this.user.logo && this.user.logo.length) {
        this.logo = this.user.logo[0].link
      } else {
        this.logo = null
      }
    },
    changeLogo () {
      if (!this.file) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selectLogo'),
          'animation-type': 'css'
        })
        return false
      }

      let data = new FormData(document.getElementById('change-logo'))

      PartnersService.changeLogo(data)
        .then((response) => {
          let userObject = this.$store.getters.user
          userObject.logo = []
          userObject.logo[0] = {}
          userObject.logo[0] = { 'link': response.data.data.logo[0].link }
          localStorage.setItem('user', JSON.stringify(userObject))
          this.logo = response.data.data.logo[0].link
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.logoAdaugat'),
            'animation-type': 'css'
          })
        })
        .catch((error) => {
          let message = error.response.data.error
          this.$notify({
            group: 'error',
            type: 'error',
            title: this.$t('errors.errorTitle'),
            text: message,
            'animation-type': 'css'
          })
        })
    },
    changePassword () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('change-pass'))
      UsersService.changePassword(formData)
        .then((response) => {
          this.$store.dispatch('showLoading')
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.parolaModificata'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          document.getElementsByName('old_pass')[0].value = ''
          document.getElementsByName('new_pass')[0].value = ''
          document.getElementsByName('confirm_pass')[0].value = ''
          this.$refs['old_pass'].reset()
          this.$refs['new_pass'].reset()
          this.$refs['confirm_pass'].reset()
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            console.log(input)
            console.log(input.offsetTop)
            console.log(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else if (error.response) {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
          this.$store.dispatch('hideLoading')
        })
    },
    smileStatus () {
      let inputStart = 0 // The lowest number of the range input.
      let inputEnd = 5000 // The lowest number of the range input.
      let outputStart = 20 // The lowest number of the range output.
      let outputEnd = 120 // The largest number of the range ouput.

      let input = 0
      if (this.user.points > inputStart && this.user.points <= inputEnd) {
        input = this.user.points
      } else if (this.user.points < 0 || !this.user.points) {
        input = 0
      } else if (this.user.points > 5000) {
        input = 5000
      }

      let output = 0
      output = outputStart + ((outputEnd - outputStart) / (inputEnd - inputStart)) * (input - inputStart)
      let pointsElem = document.getElementById('smile-container')
      // pointsElem.style.width = output + 'px'
      setTimeout(function () {
        pointsElem.style.width = output + 'px'
        pointsElem.style.transitionDuration = '1.5s'
      }, 500)
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'first_name',
            labelName: this.$t('placeholder.nume'),
            inputValue: (this.user) ? this.user.first_name : null,
            icon: 'fas fa-signature'
          },
          {
            inputName: 'last_name',
            labelName: this.$t('placeholder.prenume'),
            inputValue: (this.user) ? this.user.last_name : null,
            icon: 'fas fa-signature'
          },
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: (this.user) ? this.user.company_name : null,
            icon: 'fas fa-building'
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: (this.user) ? this.user.email : null,
            icon: 'fas fa-envelope'
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: (this.user) ? this.user.phone : null,
            icon: 'fas fa-phone'
          }
        ]
      }
    },
    input_pass_fields () {
      return {
        column_1: [
          {
            inputName: 'old_pass',
            labelName: this.$t('txt.parolaVeche'),
            icon: 'fas fa-lock',
            validationRules: 'required'
          },
          {
            inputName: 'new_pass',
            labelName: this.$t('txt.parolaNoua'),
            icon: 'fas fa-lock',
            validationRules: 'required'
          },
          {
            inputName: 'confirm_pass',
            labelName: this.$t('txt.confirmareParola'),
            icon: 'fas fa-check',
            validationRules: 'required|confirmed:new_pass'
          }
        ]
      }
    },
    input_offer_fields () {
      return {
        column_1: [
          {
            inputName: 'first_name_offer',
            inputValue: ((this.offerData && this.offerData.first_name) ? this.offerData.first_name : (this.user.first_name)) ? this.user.first_name : null,
            labelName: this.$t('placeholder.nume'),
            icon: 'fas fa-user',
            validationRules: ''
          },
          {
            inputName: 'last_name_offer',
            inputValue: ((this.offerData && this.offerData.last_name) ? this.offerData.last_name : ((this.user) ? this.user.last_name : null)),
            labelName: this.$t('placeholder.prenume'),
            icon: 'fas fa-user',
            validationRules: ''
          },
          {
            inputName: 'email_offer',
            inputValue: (this.offerData && this.offerData.email) ? this.offerData.email : (this.user.email) ? this.user.email : null,
            labelName: this.$t('placeholder.email'),
            icon: 'fas fa-envelope',
            validationRules: 'email'
          },
          {
            inputName: 'phone_offer',
            inputValue: (this.offerData && this.offerData.phone) ? this.offerData.phone : (this.user.phone) ? this.user.phone : null,
            labelName: this.$t('placeholder.telefon'),
            icon: 'fas fa-phone',
            validationRules: '',
            type: 'number'
          },
          {
            inputName: 'address_offer',
            inputValue: (this.offerData && this.offerData.address) ? this.offerData.address : (this.user.address) ? this.user.address : null,
            labelName: this.$t('placeholder.adresa'),
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          }
        ],
        column_2: [
          {
            inputName: 'company_name_offer',
            inputValue: (this.offerData && this.offerData.company_name) ? this.offerData.company_name : (this.user.company_name) ? this.user.company_name : null,
            labelName: this.$t('placeholder.numeCompanie'),
            icon: 'fas fa-building',
            validationRules: ''
          },
          {
            inputName: 'nr_reg_offer',
            inputValue: (this.offerData && this.offerData.nr_reg) ? this.offerData.nr_reg : (this.user.nr_reg) ? this.user.nr_reg : null,
            labelName: this.$t('placeholder.nrRegCom'),
            icon: 'fas fa-cash-register',
            validationRules: ''
          },
          {
            inputName: 'bank_offer',
            inputValue: (this.offerData && this.offerData.bank) ? this.offerData.bank : (this.user.bank) ? this.user.bank : null,
            labelName: this.$t('placeholder.banca'),
            icon: 'fas fa-piggy-bank',
            validationRules: ''
          },
          {
            inputName: 'cui_offer',
            inputValue: (this.offerData && this.offerData.cui) ? this.offerData.cui : (this.user.cui) ? this.user.cui : null,
            labelName: this.$t('placeholder.cui'),
            icon: 'fas fa-scroll',
            validationRules: ''
          },
          {
            inputName: 'date_corespondenta_offer',
            inputValue: (this.offerData && this.offerData.date_corespondenta) ? this.offerData.date_corespondenta : (this.user.cui) ? this.user.cui : null,
            labelName: this.$t('placeholder.dateDeCorespondenta'),
            icon: 'fas fa-info',
            validationRules: ''
          }
        ],
        locations: [
          {
            inputName: 'county_id_offer',
            inputValue: (this.offerData && this.offerData.county && this.offerData.county) ? this.offerData.county.name : ((this.user.county) ? this.user.county.name : null),
            labelName: this.$t('placeholder.judet'),
            icon: 'fas fa-building',
            validationRules: ''
          },
          {
            inputName: 'city_id_offer',
            inputValue: (this.offerData && this.offerData.city && this.offerData.city) ? this.offerData.city.name : ((this.user.city) ? this.user.city.name : null),
            labelName: this.$t('placeholder.oras'),
            icon: 'fas fa-building',
            validationRules: ''
          }
        ]
      }
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
    this.checkLogo()

    if (this.user.type !== null) {
      this.type = this.user.type
      this.userType(this.type)
    }
    this.getUserOfferData()
    this.getCounties()
  },
  mounted () {
    this.smileStatus()
  }
}
</script>
